import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
        if (data.service) {
            datas.assignment__service = data.service
        }
        if (data.assignment) {
            datas.assignment = data.assignment
        }
        if (data.from) {
            datas.from_location = data.from
        }
        if (data.to) {
            datas.to_location = data.to
        }
        if (data.assignment__service) {
            datas.assignment__service = data.assignment__service
        }
    }
    return ApiService.get('/rate-card-template/rate-card/', datas)
}
export const getNotificationData = () =>
    ApiService.get('/rate-card-template/formula-notifications/')
export const createApiRecord = (data) =>
    ApiService.filePost('/rate-card-template/rate-card/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/rate-card-template/rate-card/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.put(`/rate-card-template/rate-card/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/rate-card-template/rate-card/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/rate-card-template/rate-card', id)
export const bulkUploadApi = (data) =>
    ApiService.filePost('/rate-card-template/rate-card-upload/', data)
export const reconcileApi = (data) =>
    ApiService.post('/rate-card-template/invoice-calculation/', { data: 1 })
export const getRejectedInvoiceNotificationData = () =>
    ApiService.get(
        '/rate-card-template/approved-rejected-invoice-notifications/',
    )
export const updateRejectedInvoiceNotificationData = (id, data) =>
    ApiService.patch(
        `/rate-card-template/approved-rejected-invoice-notifications/${id}/`,
        data,
    )
export const reconcileRecordsApi = (invoiceNumber) =>
    ApiService.get(
        `/rate-card-template/reconciled-invoice-records/?invoice_num=${invoiceNumber}`,
    )
export const ApproveRejectRecordApi = (id, data) =>
    ApiService.patch(`/rate-card-template/invoice-status-log/${id}/`, data)
export const historyRecordsApi = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
        if (data.invoiceNumber) {
            datas.invoice_num = data.invoiceNumber
        }
        if (data.startDate && data.endDate) {
            datas.start_date = data.startDate
            datas.end_date = data.endDate
        }
    }
    return ApiService.get(`/rate-card-template/invoice-status-log`, datas)
}
